import { ChangeDetectionStrategy, Component, input, output, viewChild } from '@angular/core';
import { FormOption } from '@core/navigation/store/state';
import { BreadcrumbItem, BreadcrumbItemComponent } from './breadcrumb-item/breadcrumb-item.component';
import { FormSelectorComponent } from './form-selector/form-selector.component';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-long-breadcrumb',
    templateUrl: './long-breadcrumb.component.html',
    styleUrls: ['./long-breadcrumb.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        BreadcrumbItemComponent,
        MatIcon,
        FormSelectorComponent,
    ]
})
export class LongBreadcrumbComponent {
  readonly breadcrumbs = input<BreadcrumbItem[]>([]);
  readonly forms = input<FormOption[]>([]);
  readonly homeClicked = output();
  readonly breadcrumbClicked = output<BreadcrumbItem>();
  readonly formSelected = output<string>();

  readonly formSelector = viewChild(FormSelectorComponent);
}
